import {inject, Injectable} from '@angular/core';
import {TranslocoService} from '@jsverse/transloco';
import {lastValueFrom} from 'rxjs';
import {Language} from './models/language';
import {LanguageOption} from './models/language-option';
import {DirectusService} from './directus.service';

@Injectable({providedIn: 'root'})
export class DirectusLoader {
  private directusService = inject(DirectusService);
  private translocoService = inject(TranslocoService);

  availableLanguages: Language[] = [];

  loadLanguages(): Promise<void> {
    return lastValueFrom(this.directusService.loadLanguages())
      .then((languages: Language[]) => {
        if (languages) {
          this.availableLanguages = languages.map((lang: Language) => {
            return {code: lang.code, localized_name: lang.localized_name || {}};
          });
        } else {
          console.warn('No data received from Directus for languages.');
          this.setFallbackLanguage();
        }
      })
      .catch(() => {
        this.setFallbackLanguage();
      });
  }

  getLanguageOptions(): LanguageOption[] {
    const activeLanguage: string = this.translocoService.getActiveLang();

    return this.availableLanguages.map((current: Language) => {
      const option: LanguageOption = {
        key: current.code,
        value: current.localized_name[activeLanguage],
      };

      return option;
    });
  }

  private setFallbackLanguage() {
    this.availableLanguages = [{code: 'en', localized_name: {en: 'English'}}];
  }
}
